import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { HomeLocationsComponent } from '../home/home-locations/home-locations.component';
import { AppMainService } from '../../core/services/core/app-main.service';
import { finalize } from 'rxjs';
import { Address } from '../../core/api/models';
import { Router, RouterLink } from '@angular/router';
import { AnalyticsService } from '../../core/services/shared/analytics.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HomeLocationsComponent, ButtonComponent, RouterLink],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly appMainService = inject(AppMainService);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private analytics = inject(AnalyticsService);

  mainAddress = signal<Address | null>(null);
  isSubmitting = signal(false);
  isSuccess = signal(false);
  isError = signal(false);

  contactForm = this.fb.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required]],
    message: ['', [Validators.required, Validators.minLength(10)]],
  });

  locations = [
    // {
    //   title: 'Pier J at Marina Del Sol',
    //   description:
    //     'Discover exclusive brokerage slips on pier J located within Marina Del Sol on Clear Lake. We offer twelve forty to fifty foot slips nestled within a quiet and community oriented atmosphere. Experience the perfect blend of luxury and class on pier J at Marina Del Sol.',
    //   image: 'assets/images/home/locations/jmk5.jpg',
    // },
    {
      title: 'Pier 27 at Watergate Marina',
      description:
        'Set sail from the finest seat in the house. We offer an exclusive collection of seventeen (17) 40’ slips on pier 27 at Watergate Marina. Dredged to 8’ and with beautiful views of Clear Lake, pier 27 provides the perfect starting point for your adventures to both domestic and international waterways. Discover why pier 27 at Watergate Marina is the premier choice for your yachting needs.',
      image: 'assets/images/home/locations/watergate.jpg',
    },
  ];

  ngOnInit(): void {
    this.appMainService.getMasterConfig().subscribe({
      next: (master) => {
        if (master?.appMain) {
          this.mainAddress.set(master.appMain.mainLocation?.address || null);
        }
      },
    });
  }

  onSubmit() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      this.cdr.markForCheck();
      return;
    }

    this.isSubmitting.set(true);
    this.isSuccess.set(false);
    this.isError.set(false);

    const formValue = this.contactForm.getRawValue();

    this.appMainService
      .sendContactUsMessage({
        firstName: formValue.firstName || '',
        lastName: formValue.lastName || '',
        email: formValue.email || '',
        phone: formValue.phone || '',
        message: formValue.message || '',
      })
      .pipe(finalize(() => this.isSubmitting.set(false)))
      .subscribe({
        next: () => {
          this.isSuccess.set(true);
          this.contactForm.reset();
          this.analytics.trackLead('contact');
        },
        error: () => this.isError.set(true),
      });
  }

  navigateToPortal() {
    this.router.navigate(['/privacy-policy']);
  }
}
